import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

interface NocProviderState {
    status: []
}
const initialState = {
    status: []
} as NocProviderState

const NocProviderSlice = createSlice({
    name: 'NocProvider',
    initialState,
    reducers: {
        setStatus: (state, action: PayloadAction<any>) => {
            state.status = action.payload;
        }
    }
})
export const { setStatus } = NocProviderSlice.actions;

export const fetchListNocProvider = (payload?: any): AppThunk<any> => async () => {
    try {
        const resp = await api.post(API_URL.NOC_PROVIDER.LIST, payload);
        return Promise.resolve(resp.data.data)
    } catch (error: any) {
        return Promise.reject(error.data)
    }
}
export const editNocProvider =
    (payload?: any): AppThunk<any> =>
        async (dispatch) => {
            try {
                const response = await api.post(API_URL.NOC_PROVIDER.EDIT, payload);
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };
export const addNocProvider = (payload?: any): AppThunk<any> =>
    async (dispatch) => {
        try {
            const response = await api.post(API_URL.NOC_PROVIDER.ADD, payload);
            return Promise.resolve(response.data);
        } catch (error: any) {
            return Promise.reject(error.data);
        }
    };
export const deleteNocProvider =
    (payload?: any): AppThunk<any> =>
        async (dispatch) => {
            try {
                const response = await api.post(API_URL.NOC_PROVIDER.DELETE, payload);
                return Promise.resolve(response.data);
            } catch (error: any) {
                return Promise.reject(error.data);
            }
        };

export default NocProviderSlice.reducer